export var Type = {
  Input: 'input',
  Textarea: 'textarea'
};